import { Reveal } from "./Reveal";
import { COMPARISON } from "@/lib/data";
import { Check, X } from "lucide-react";

export function Comparison() {
  return (
    <section id="compare" data-testid="comparison-table" className="mx-auto max-w-5xl px-4 py-24 sm:px-6 lg:py-32">
      <Reveal className="text-center">
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-cyan-400/90">The Honest Math</p>
        <h2 className="font-display mt-3 text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
          The Reset vs. pills, apps & subscriptions
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base text-slate-400">
          Sleep aids rent you relief by the night. This rebuilds the skill — once.
        </p>
      </Reveal>

      <Reveal delay={0.1} className="mt-12">
        <div className="overflow-hidden rounded-3xl border border-white/10">
          <div className="hidden grid-cols-3 bg-[#131a29] px-6 py-4 text-sm font-semibold sm:grid">
            <span className="text-slate-400">Question</span>
            <span className="text-cyan-300">ASTRA Sleep Reset</span>
            <span className="text-slate-500">Pills & sleep apps</span>
          </div>
          {COMPARISON.map((row, i) => (
            <div
              key={row.label}
              data-testid={`comparison-row-${i}`}
              className={`grid grid-cols-1 gap-3 px-5 py-5 text-sm sm:grid-cols-3 sm:items-center sm:gap-2 sm:px-6 sm:py-4 ${i % 2 ? "bg-[#0e131f]" : "bg-[#0b0f18]"}`}
            >
              <span className="font-display text-base font-bold text-white sm:text-sm sm:font-medium sm:text-slate-300">{row.label}</span>
              <span className="flex items-start gap-2 text-slate-100">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" />
                <span><span className="mb-0.5 block font-mono text-[10px] uppercase tracking-[0.18em] text-cyan-400 sm:hidden">Sleep Reset</span>{row.astra}</span>
              </span>
              <span className="flex items-start gap-2 text-slate-500">
                <X className="mt-0.5 h-4 w-4 shrink-0 text-rose-500/70" />
                <span><span className="mb-0.5 block font-mono text-[10px] uppercase tracking-[0.18em] text-slate-600 sm:hidden">Pills & apps</span>{row.generic}</span>
              </span>
            </div>
          ))}
        </div>
      </Reveal>
    </section>
  );
}
